import React, { useCallback, useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { homeSettingState } from '@atom/setting/homeSettingState';
import { getArrowButtonComponent } from './designs';
import { ArrowButtonDesignType } from '@typings/setting/homepageSetting.interface';

interface Props {
  onClick: () => void;
  style?: any;
  color?: string;
  backgroundColor?: string;
  pointColor?: string;
  design?: ArrowButtonDesignType;
}

function BackBtn({
  onClick,
  style,
  color,
  backgroundColor,
  pointColor,
  design,
}: Props) {
  const homeSetting = useRecoilValue(homeSettingState);
  const arrowBtnConfig = homeSetting?.arrowButton;

  // 관리자 설정값을 기본값으로, props가 있으면 props 우선
  const resolvedColor = color || arrowBtnConfig?.color;
  const resolvedBg = backgroundColor || arrowBtnConfig?.backgroundColor;
  const resolvedPoint = pointColor || arrowBtnConfig?.pointColor;
  const designType = design || arrowBtnConfig?.design || 'diaArrow';

  const DesignComponent = useMemo(
    () => getArrowButtonComponent(designType),
    [designType],
  );

  const handleClick = useCallback(() => {
    if (onClick) onClick();
  }, [onClick]);

  return (
    <button onClick={handleClick} style={style} data-sound-type="default">
      <DesignComponent
        color={resolvedColor}
        backgroundColor={resolvedBg}
        pointColor={resolvedPoint}
        direction="left"
      />
    </button>
  );
}

export default React.memo(BackBtn);
